import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { Asset } from './Asset';

@supertypeClass({ toClient: true, toServer: true })
export class Insurance extends Asset {
  @property({ rule: ['required'], validate: 'isWithin(1, 100)' })
  years: number = 20;

  @property()
  type: string = 'term';

  @property({ rule: ['required', 'numeric'], validate: 'isWithin(1900, 2017)' })
  year: number = 2017;

  @property({
    values: function () {
      return this.customer.profile.relationship === 'single' ? ['false'] : ['false', 'true'];
    },
    descriptions: function () {
      return {
        false: this.customer.primaryCustomer.firstName,
        true: this.customer.alternateCustomer.firstName,
      };
    },
  })
  forAlternate: boolean;

  @property({ values: { false: 'No', true: 'Yes' } })
  isPortable: boolean;

  @property({ values: { false: 'No', true: 'Yes' } })
  willReplace: boolean;

  @property({ rules: ['text'] })
  company: string;

  @property({ length: 20, rules: ['text'], sensitiveData: true })
  policyNumber: string;

  @property()
  insured;

  constructor() {
    super();
  }

  static new(customer, amount, insured) {
    return new Insurance().init(customer, amount, insured);
  }

  init(customer, amount, insured) {
    super.init(customer, 'insurance', amount);

    this.insured = insured;
    return this;
  }

  isActive(deceasedPerson?) {
    return deceasedPerson === this.customer.alternateCustomer ? this.forAlternate : !this.forAlternate;
  }
}
